import { isMobile, isWeb, isTablet } from '../../../../lib/getDeviceSize';

const styles: any = {
  averages: {
    marginTop: 15,
    textAlign: 'left',
  },
  bottomLeftItem: {
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 1,
    borderTopWidth: 0,
    width: '33.33%',
  },
  bottomMiddleItem: {
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 1,
    borderTopWidth: 0,
    width: '33.33%',
  },
  bottomRightItem: {
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopWidth: 0,
    width: '33.33%',
  },
  expandButtonStyle: {
    minWidth: 30,
    padding: 0,
  },
  infoListStyle: {
    color: '#323232',
    fontSize: 14,
  },
  loader: {
    marginTop: 15,
  },
  mobileSummaryContainer: {
    backgroundColor: '#fff',
    borderBottom: '1px solid #C3CAD6',
    marginTop: -1,
    padding: 15,
    position: 'absolute',
    top: 0,
    width: '100%',
    zIndex: 20,
  },
  spaceBetween: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  summaryContainer: {
    alignSelf: 'center',
    width: '100%',
  },
  titleStyle: {
    color: '#0E1217',
    fontSize: 16,
    fontWeight: 'bold',
  },
  topLeftItem: {
    borderBottomWidth: 1,
    borderLeftWidth: 0,
    borderRightWidth: 1,
    borderTopWidth: 0,
    width: '33.33%',
  },
  topMiddleItem: {
    borderBottomWidth: 1,
    borderLeftWidth: 0,
    borderRightWidth: 1,
    borderTopWidth: 0,
    width: '33.33%',
  },
  topRightItem: {
    borderBottomWidth: 1,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopWidth: 0,
    width: '33.33%',
  },
};

export default styles;
